import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import get from 'lodash.get';
import { getUrlString, updateSearchObject, getUrlParams } from '../../../../utils/shared/urlUtils';
import LinkWrapper from '../../../../features/navigation/LinkWrapper';
import { selectors } from '../../../../root/reading/root';
import TroProbeDetails from '../../../../features/probeDetails/reading/tro/TroProbeDetails';
import {
    closeTroConfirmationPopup,
    fetchTroBookData,
    patchTroBookData,
    revertTroBookData,
    showTroConfirmationPopup,
} from '../../../../api/troBooksData/troBooksDataActions';
import { fetchTroAudioData } from '../../../../api/results/reading/resultActions';
import {
    getSelectedBookId,
    getBooksInformation,
} from '../../../../features/probeDetails/reading/tro/troProbeDetailsHelper';
import getTroNavTabs from '../../../../features/probeDetails/reading/tro/troNavTabs';
import { getCompletedBookResults } from '../../../../utils/reading/resultReducerHelper';
import {
    REVERT_MODAL,
    UNTRANSCRIBABLE_MODAL,
    TRO_LRS_CONSTANTS,
} from '../../../../constants/reading/TroConstants';
import {
    troAudioPlayerEvent,
    troBookRescoringEvent,
    troRevertEvent,
    troNotScoredBookRescoringEvent,
} from '../../../../api/lrs/reading/lrsActions';
import { ID } from '../../../../constants/shared/TrcConstants';

const { STARTED, FINISHED } = TRO_LRS_CONSTANTS;

const mapStateToProps = (state, { result }) => {
    const location = selectors.getLocation(state);
    const urlParams = getUrlParams(location);
    const selectedBookId = getSelectedBookId(result, urlParams.bookId);
    const bookResults = [...getCompletedBookResults(result.measureResult)].reverse();
    const currentBookResult = selectors.getBookResultById({}, { result, selectedBookId });
    const { isUntranscribable } = get(currentBookResult, 'vrrResult', {});

    return {
        location,
        selectedBookId,
        userId: selectors.getUserId(state),
        isUntranscribable,
        windowDates: selectors.getWindowDates(state),
        currentPeriod: selectors.getCurrentPeriod(state),
        isChosenSchoolWindowDatesStrictlyEnforced:
            selectors.isChosenSchoolWindowDatesStrictlyEnforced(state),
        // for component
        currentBookResult,
        isTroAudioFetching: selectors.isTroAudioFetching(state),
        booksData: selectors.getTroBooksData(state),
        readingStats: selectors.getReadingStats(state, { result, selectedBookId }),
        selectedTabId: urlParams.tab,
        student: selectors.getStudentById(state, result.studentId),
        navTabs: getTroNavTabs(urlParams),
        booksInformation: getBooksInformation(bookResults),
        listOfSentences: selectors.getTROSentences(state, { result, selectedBookId }),
        isTroRemarksUpdating: selectors.isTroRemarksUpdating(state),
        confirmationModalType: selectors.showTroConfirmationPopup(state),
        LinkWrapper,
        toyPeriods: selectors.getToyPeriods(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { result } = ownProps;

    return {
        dispatch,
        selectDefaultTab: location =>
            dispatch(
                push(
                    getUrlString(location.pathname, {
                        ...updateSearchObject(location, ['tab'], { tab: ID.READING_TRANSCRIPT }),
                    }),
                ),
            ),
        selectBook: (location, bookId) => {
            dispatch(
                push(
                    getUrlString(location.pathname, {
                        ...updateSearchObject(location, ['bookId'], { bookId }),
                    }),
                ),
            );
        },
        patchBookContentRemarks: (
            resultId,
            bookId,
            audioSrc,
            userId,
            complexityLevel,
            isUntranscribable,
            data,
        ) => {
            if (isUntranscribable) {
                dispatch(troNotScoredBookRescoringEvent(FINISHED));
            }
            dispatch(troBookRescoringEvent(FINISHED, complexityLevel));
            dispatch(
                patchTroBookData(resultId, result, bookId, audioSrc, userId, data, complexityLevel),
            );
        },
        revertToSoapBoxResult: (resultId, userId, troAudioSrc, bookId) => {
            dispatch(closeTroConfirmationPopup());
            dispatch(revertTroBookData(resultId, userId, troAudioSrc, bookId));
            dispatch(troRevertEvent());
        },
        fetchAudioData: (studentId, resultId, bookId) =>
            dispatch(fetchTroAudioData(studentId, resultId, bookId)),
        fetchBookContent: bookId => dispatch(fetchTroBookData(bookId)),
        showRevertModal: () => dispatch(showTroConfirmationPopup({ modalType: REVERT_MODAL })),
        showUntranscribableModal: () =>
            dispatch(showTroConfirmationPopup({ modalType: UNTRANSCRIBABLE_MODAL })),

        closeConfirmationPopup: (isUntranscribable = false) => {
            if (isUntranscribable) {
                dispatch(troNotScoredBookRescoringEvent(STARTED));
            }
            dispatch(closeTroConfirmationPopup());
        },
        audioLookerEvent: () => dispatch(troAudioPlayerEvent()),
        troBookRescoringEvent: complexityLevel =>
            dispatch(troBookRescoringEvent(STARTED, complexityLevel)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { resultId, studentId } = ownProps.result;
    const { selectedBookId, userId, currentBookResult, isUntranscribable, location } = stateProps;
    const { audioSrc } = get(currentBookResult, 'vrrResult', {});
    const { relativeLevel: complexityLevel } = currentBookResult;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        fetchAudioData: () => dispatchProps.fetchAudioData(studentId, resultId, selectedBookId),
        revertToSoapBoxResult: () =>
            dispatchProps.revertToSoapBoxResult(resultId, userId, audioSrc, selectedBookId),
        patchBookContentRemarks: data =>
            dispatchProps.patchBookContentRemarks(
                resultId,
                selectedBookId,
                audioSrc,
                userId,
                complexityLevel,
                isUntranscribable,
                data,
            ),
        troBookRescoringEvent: () => dispatchProps.troBookRescoringEvent(complexityLevel),
        selectDefaultTab: () => dispatchProps.selectDefaultTab(location),
        selectBook: bookId => dispatchProps.selectBook(location, bookId),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TroProbeDetails);
